export default __webpack_public_path__ + "static/media/item4.46117420.jpg";